/**
 * FR-95: lists and reports need every row, not the first 20 × 15. The API caps
 * `per_page` at 500; the page cap only guards against a runaway loop.
 */
export const FETCH_ALL_PER_PAGE = 500;
export const FETCH_ALL_MAX_PAGES = 200;
